import Navbar from "@/app/components/navbar/Navbar";
import React from "react";
import Footer from "@/app/components/footer/Footer";

function Wrapper({children, className,isHomepage = false}) {
    return (<>
            <Navbar/>
            <div className={className} style={{paddingLeft: '5vw', paddingRight: '5vw'}}>
                {children}
            </div>
        {!isHomepage && <Footer />}
        </>);
}

export default Wrapper;
